import { configureStore } from '@reduxjs/toolkit';
import { authSlice } from './auth';
import { loadingSlice } from './loading';
import { globalsSlice } from './globals';
import { companySlice } from './company';
import { departamentSlice } from './departament';
import { municipalySlice } from './municipaly';
import { paymentFrequencySlice } from './payment_frequency';
import { paymentMethodSlice } from './payment_method';
import { associatedBankSlice } from './associated_bank';
import { TypeAccountBankSlice } from './type_account_bank';
import { SgsstSlice } from './sgsst';
import { ArlSlice } from './arl';
import { economicActivitySlice } from './economic_activity';
import { ErrorsSlice } from './errors';
import { permissonsSlice } from './permissions';
import { AreaSlice } from './areas';
import { CargoSlice } from './cargos';
import { LogSlice } from './logs';
import { typeDocumentSlice } from './type_document';
import { EpsSlice } from './eps';
import { FamilyCompensationSlice } from './family_compensation_fund';
import { CesantiasSlice } from './severance';
import { PensionSlice } from './pension';
import { SizeFamilySlice } from './size_family';
import { EmployeeSlice } from './employee';
import { TurnoSlice } from './shifts';
import { Parametroslice } from './parameters';
import { TipoNovedadSlice } from './tipo_novedad';
import { CustomerSlice } from './customer';
import { novedadesTurnoSlice } from './novedadesTurnos';
import { UsersPermissionsSlice } from './users_permissions';
import { countrySlice } from './country';
import { workPlaceSlice } from './work_place';
import { sucursalSlice } from './sucursal';
import { shiftsEmployeesSlice } from './shifts_employees';
import { Terminalslice } from './terminals-empleados';
import { ActionTipoNovedadSlice } from './action_type_new';
import { ResultTipoNovedadSlice } from './result_type_new';
import { controlTiemposSlice } from './control_tiempos';
import { notificationsSlice } from './notifications';
import { ExpressCheckinSlice } from './express-checkin';
import { RegistroExpressCheckinSlice } from './registro-express-checkin';
import { TerminalDescansoslice } from './terminal-descansos';
import { SizeItemsSlice, storeSizeItems } from './size_items';
import { MainSlice } from './main-data';
import { ordenesDeServicioSlice } from './ordenes-de-servicios';
import { tipoCotizacionSlice } from './tipo-cotizacion';
import { categoriaCotizacionSlice } from './categoria-cotizacion';
import { ApplicationSlice } from './applications';
import { RatingsSlice } from './ratings';
import { passwordSlice } from './password';
import { SlaSlice } from './sla';
import { LinksEncuestasSlice } from './links_encuestas';
import { shiftTemplatesSlice } from './shift_templates';
import { positionSchedulingRulesSlice } from './position_scheduling_rules';
import { shiftSchedulingGlobalRulesSlice } from './shift_scheduling_global_rules';
import { EmployeeAbsencesSlice } from './employee_absences';
import { shiftDemandsSlice } from './shift_demands/shiftDemandsSlice';
import { shiftGeneratorSlice } from './shift_generator';
import { appReleasesSlice } from './app-releases';
import { servicesIaSlice } from './services-ia';
import { servicesIaGlobalConfigSlice } from './services-ia-global-config';
import { knowledgeBasesSlice } from './knowledge-bases';
import { agentesSlice } from './agentes';
import { assistantsSlice } from './assistants';
import { servicesIaPlansSlice } from './services-ia-plans';
import { servicesIaCustomerSuscriptionsSlice } from './services-ia-customer-suscriptions';
import { servicesIaBalanceSlice } from './services-ia-balance';
import { servicesIaCreditTransactionsSlice } from './services-ia-credit-transactions';
import { servicesIaUsageDailysSlice } from './services-ia-usage-dailys';
import { servicesIaUsageMonthlysSlice } from './services-ia-usage-monthlys';
import { contratosSlice } from './contratos/contratos.slice';

export default configureStore({
  reducer: {
    auth: authSlice.reducer,
    loading: loadingSlice.reducer,
    globals: globalsSlice.reducer,
    company: companySlice.reducer,
    departaments: departamentSlice.reducer,
    municipalies: municipalySlice.reducer,
    paymentfrequency: paymentFrequencySlice.reducer,
    paymentmethod: paymentMethodSlice.reducer,
    associatedbank: associatedBankSlice.reducer,
    typeaccountbank: TypeAccountBankSlice.reducer,
    sgsst: SgsstSlice.reducer,
    arl: ArlSlice.reducer,
    economicactivity: economicActivitySlice.reducer,
    errors: ErrorsSlice.reducer,
    permissions: permissonsSlice.reducer,
    areas: AreaSlice.reducer,
    cargos: CargoSlice.reducer,
    logs: LogSlice.reducer,
    tipodocumento: typeDocumentSlice.reducer,
    eps: EpsSlice.reducer,
    cajaCompensacion: FamilyCompensationSlice.reducer,
    cesantias: CesantiasSlice.reducer,
    pension: PensionSlice.reducer,
    sizefamily: SizeFamilySlice.reducer,
    sizeItems: SizeItemsSlice.reducer,
    employee: EmployeeSlice.reducer,
    turnos: TurnoSlice.reducer,
    parametros: Parametroslice.reducer,
    tiponovedades: TipoNovedadSlice.reducer,
    customer: CustomerSlice.reducer,
    novedadesTurno: novedadesTurnoSlice.reducer,
    usersPermissions: UsersPermissionsSlice.reducer,
    country: countrySlice.reducer,
    workplace: workPlaceSlice.reducer,
    sucursales: sucursalSlice.reducer,
    tipoTurnos: shiftsEmployeesSlice.reducer,
    terminals: Terminalslice.reducer,
    terminalDescansos: TerminalDescansoslice.reducer,
    actionTipoNovedad: ActionTipoNovedadSlice.reducer,
    resultTipoNovedad: ResultTipoNovedadSlice.reducer,
    controlTiempos: controlTiemposSlice.reducer,
    notifications: notificationsSlice.reducer,
    expressCheckin: ExpressCheckinSlice.reducer,
    registroExpressCheckin: RegistroExpressCheckinSlice.reducer,
    main: MainSlice.reducer,
    ordenesDeServicio: ordenesDeServicioSlice.reducer,
    tipoCotizacion: tipoCotizacionSlice.reducer,
    categoriaCotizacion: categoriaCotizacionSlice.reducer,
    application: ApplicationSlice.reducer,
    ratingsDevices: RatingsSlice.reducer,
    password: passwordSlice.reducer,
    sla: SlaSlice.reducer,
    linksEncuestas: LinksEncuestasSlice.reducer,
    shiftTemplates: shiftTemplatesSlice.reducer,
    positionSchedulingRules: positionSchedulingRulesSlice.reducer,
    shiftSchedulingGlobalRules: shiftSchedulingGlobalRulesSlice.reducer,
    employeeAbsences: EmployeeAbsencesSlice.reducer,
    shiftDemands: shiftDemandsSlice.reducer,
    shiftGenerator: shiftGeneratorSlice.reducer,
    appReleases: appReleasesSlice.reducer,
    servicesIa: servicesIaSlice.reducer,
    servicesIaGlobalConfig: servicesIaGlobalConfigSlice.reducer,
    knowledgeBases: knowledgeBasesSlice.reducer,
    agentes: agentesSlice.reducer,
    assistants: assistantsSlice.reducer,
    servicesIaPlans: servicesIaPlansSlice.reducer,
    servicesIaSuscriptions: servicesIaCustomerSuscriptionsSlice.reducer,
    servicesIaBalance: servicesIaBalanceSlice.reducer,
    servicesIaCreditTransactions: servicesIaCreditTransactionsSlice.reducer,
    servicesIaUsageDailys: servicesIaUsageDailysSlice.reducer,
    servicesIaUsageMonthlys: servicesIaUsageMonthlysSlice.reducer,
    contratos: contratosSlice.reducer,
  },
});
